import { dynamicLastQuoteApi } from 'apiConnector/quote/dynamicLastQuote';
import { tabRemoved } from 'epic/workspace/common/tabs/tabsEpics';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { of, throwError } from 'rxjs';
import { catchError, filter, mergeMap, takeUntil, timeoutWith } from 'rxjs/operators';
import { dynamicPreviousQuoteLoadedThunk } from 'state/dynamic/dynamicForm.thunks';
import { commonQuoteAction } from 'state/forms/actions/quote';
import type { EpicWithThunk } from 'state/state.common';

export function fetchDynamicLastQuoteEpic(
  timeoutInMillis: number = 60000,
  appScheduler?: SchedulerLike,
): EpicWithThunk {
  return (action$, state$, { httpClient }) =>
    action$.pipe(
      ofType('PREVIOUS_QUOTE_LOAD_REQUESTED'),
      filter(action => action.workspace === 'dynamic'),
      mergeMap(({ tabId, quoteId }) => {
        const tabRemoved$ = tabRemoved(action$, tabId, state$);
        const api = dynamicLastQuoteApi(httpClient);
        return api
          .getLastQuote(quoteId)
          .pipe(
            mergeMap(quoteWithRegulation => of(dynamicPreviousQuoteLoadedThunk(tabId, quoteId, quoteWithRegulation))),
            timeoutWith(timeoutInMillis, throwError('Timeout'), appScheduler),
            catchError(_ => {
              return of(commonQuoteAction.previousQuoteLoadingFailed('dynamic', tabId, quoteId));
            }),
          )
          .pipe(takeUntil(tabRemoved$));
      }),
    );
}
